module.exports = __webpack_public_path__ + "34736292/img/verified-icon.f93bbc14.svg";